export default class SwitchPricingEvent {
    export() {
        return {
            pricing: this.pricing,
        };
    }
}
